/* Scoped forward-only announcements. Keeps all Shopify announcement blocks. */
(() => {
  const selector = '.section-announcement-bar slideshow-component.announcement-bar';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const delay = 460;

  function initialize(component, attempt = 0) {
    if (!component || component.dataset.enForwardReady === '1') return;
    const slider = component.querySelector('.announcement-bar-slider .slider');
    const slides = [...(slider?.querySelectorAll(':scope > .slideshow__slide') || [])];
    if (!slider || slides.length < 2) return;
    // Native autoplay is already disabled in Liquid; it may not be initialized yet.
    slider.dataset.autoplay = 'false';
    component.announcementBarArrowButtonWasClicked = true;
    const originalHeight = Math.max(44, Math.ceil(slider.getBoundingClientRect().height));
    slider.style.setProperty('--en-forward-height', originalHeight + 'px');
    slider.scrollLeft = 0;
    component.dataset.enForwardReady = '1';

    slides.forEach(slide => {
      slide.classList.remove('hidden-during-load',
        'announcement-bar-slider--fade-in-next',
        'announcement-bar-slider--fade-out-next',
        'announcement-bar-slider--fade-in-previous',
        'announcement-bar-slider--fade-out-previous');
      slide.classList.remove('en-forward-current', 'en-forward-incoming', 'en-forward-outgoing');
    });

    let current = 0;
    let busy = false;
    let running = null;
    let stopped = false;

    function activate(index) {
      slides.forEach((slide, i) => {
        slide.classList.toggle('en-forward-current', i === index);
        slide.setAttribute('aria-hidden', String(i !== index));
        if (i !== index) slide.setAttribute('tabindex', '-1');
        else slide.removeAttribute('tabindex');
      });
    }
    activate(current);
    component.classList.add('en-announcement-forward');

    const speed = Math.max(2500, (Number(slider.dataset.speed) || 3) * 1000);
    function move() {
      if (busy || !document.contains(component) || document.hidden || reducedMotion.matches) return;
      busy = true;
      const next = (current + 1) % slides.length;
      const outgoing = slides[current], incoming = slides[next];

      incoming.classList.add('en-forward-prepared');
      requestAnimationFrame(() => requestAnimationFrame(() => {
        outgoing.classList.add('en-forward-outgoing');
        incoming.classList.add('en-forward-incoming');
        incoming.classList.remove('en-forward-prepared');
        setTimeout(() => {
          outgoing.classList.remove('en-forward-outgoing', 'en-forward-current');
          incoming.classList.remove('en-forward-incoming');
          current = next;
          activate(current);
          busy = false;
        }, delay + 45);
      }));
    }
    function pause() { if (running) clearInterval(running); running = null; }
    function play() { pause(); if (!stopped && !reducedMotion.matches) running = setInterval(move, speed); }
    component.addEventListener('mouseenter', pause);
    component.addEventListener('mouseleave', play);
    component.addEventListener('focusin', pause);
    component.addEventListener('focusout', event => {
      if (!component.contains(event.relatedTarget)) play();
    });
    document.addEventListener('visibilitychange', () => {
      if (!document.contains(component)) { stopped = true; pause(); }
      else if (document.hidden) pause(); else play();
    });
    reducedMotion.addEventListener('change', () => {
      if (reducedMotion.matches) pause(); else play();
    });
    play();
  }

  function start() {
    document.querySelectorAll(selector).forEach(component => initialize(component));
  }
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();